export default {
  links: [
    {
      name: 'Ich habe eine Frage',
      link: '/pg/form_contact/',
    },
    {
      name: 'Nützliche Informationen',
      link: '/pg/info/',
    },
    {
      name: 'Datenschutz',
      link: '/pg/privacy/',
    },
    {
      name: 'Impressum',
      link: '/pg/imprint/',
    },
    {
      name: 'Buchungsanfrage',
      link: '/pg/booking/',
    },
  ],
};
